/* eslint-disable */
import numeral from 'numeral';

Vue.filter('currency', value => {
    value = typeof value === 'string' ? parseFloat(value) : value;
    return numeral(value).format('$0,0');
});

Vue.filter('capitalize', value => {
    return value ? value.substr(0, 1).toUpperCase() + value.substr(1).toLowerCase() : '';
});


// WEBPACK FOOTER //
// ./src/filters/index.js